import { RadPagination } from '../common/RadPagination'

export function BottomPagination ({ currentPageIndex, count, pageLength, searchParams, setSearchParams }) {
  return (
    <div className='bottom-pagination'>
      <RadPagination
        currentPageIndex={currentPageIndex}
        pagesCount={Math.ceil(count / pageLength)}
        onChange={({ detail }) => {
          searchParams.set('page', detail.currentPageIndex)
          setSearchParams(searchParams)
          window.scrollTo(0, 0)
        }}
        ariaLabels={{
          nextPageLabel: 'Next page',
          previousPageLabel: 'Previous page',
          pageLabel: pageNumber => `Page ${pageNumber} of all pages`
        }}
      />
    </div>
  )
}
